const i18n = {
    structure: 'multiple_files',
    locales: [ 'en', 'cn' ],
    default_locale: 'en'
}


export default i18n;
